export const formatMoney = (amount, currency = "EUR") => {
  const value = Number(amount);
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency, currencyDisplay: "code" }).format(Number.isFinite(value) ? value : 0);
};
export const formatDate = (value) => {
  if (!value || Number.isNaN(new Date(value).getTime())) return "Date inconnue";
  return new Date(value).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" });
};
